'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { OverviewTable } from '@/components/page-builder/global/pricingV1/overview/OverviewTable';
import { PlanTabs } from '@/components/page-builder/global/pricingV1/shared/PlanTabs';
import { cn } from '@/lib/styles';
import { PRICING_TEST_IDS } from '@/lib/test-ids';
export function PlanOverview(t0) {
  const $ = _c(19);
  const {
    data,
    yearly,
    currentTab,
    setCurrentTab,
    stickyTopOffset
  } = t0;
  let t1;
  if ($[0] !== data || $[1] !== stickyTopOffset || $[2] !== yearly) {
    t1 = item => <OverviewTable data={data} currentTab={item.title} yearly={yearly} stickyTopOffset={stickyTopOffset} />;
    $[0] = data;
    $[1] = stickyTopOffset;
    $[2] = yearly;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currentTab || $[5] !== data || $[6] !== setCurrentTab || $[7] !== t1) {
    t2 = <PlanTabs currentTab={currentTab} setCurrentTab={setCurrentTab} data={data} renderContent={t1} className="w-full py-3 lg:hidden" />;
    $[4] = currentTab;
    $[5] = data;
    $[6] = setCurrentTab;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = !yearly && "max-w-172 mx-auto";
  let t4;
  if ($[9] !== t3) {
    t4 = cn("hidden lg:block", t3);
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== data || $[12] !== stickyTopOffset || $[13] !== t4 || $[14] !== yearly) {
    t5 = <OverviewTable className={t4} data={data} yearly={yearly} stickyTopOffset={stickyTopOffset} />;
    $[11] = data;
    $[12] = stickyTopOffset;
    $[13] = t4;
    $[14] = yearly;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t5) {
    t6 = <div data-test-id={PRICING_TEST_IDS.LIST} className="bg-brand-black text-neutral-light-100">{t2}{t5}</div>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}